import { ca } from '@cian/analytics';

import { getAllProducs } from '../../../utils/trackings';
import { IPrintOptions } from '../../../types/redux/print';
import { IFavoriteEntity } from '../../../types/results';

export enum ETrackPrintLabels {
  WithoutNumberComment = 'WithoutNumber/Comment',
  WithNumber = 'WithNumber',
  WithComment = 'WithComment',
  WithNumberComment = 'WithNumber/Comment',
}

export function trackPrintConfirm(favoriteEntities: IFavoriteEntity[], options: IPrintOptions) {
  const products = getAllProducs({ favoriteEntities });
  let label;

  if (options.printPhoneNumbers && options.printNotes) {
    label = ETrackPrintLabels.WithNumberComment;
  } else if (options.printPhoneNumbers && !options.printNotes) {
    label = ETrackPrintLabels.WithNumber;
  } else if (!options.printPhoneNumbers && options.printNotes) {
    label = ETrackPrintLabels.WithComment;
  } else {
    label = ETrackPrintLabels.WithoutNumberComment;
  }

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'print_ads_button',
    label,
    products,
  });
}
